import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CacheInterceptor, DcLibCoreModule } from '@datachain/ui-sdk/common';

import { UiModule } from '../ui/ui.module';
import { AuthInterceptor } from './auth.interceptor';
import { ANGULARJS_BOOTSTRAP_TIMEOUT } from './bootstrap-timeout.token';
import { DcDeleteErrorsInterceptor } from './dc-delete-error.interceptor';
import { DcErrorsInterceptor } from './dc-errors.interceptor';
import { DcLanguageInterceptor } from './dc-language.interceptor';
import { ProjectStorage } from './project.storage';

@NgModule({
	imports: [
		BrowserAnimationsModule,
		CommonModule,
		HttpClientModule,
		UiModule,
		DcLibCoreModule,
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: DcLanguageInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: CacheInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: DcErrorsInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: DcDeleteErrorsInterceptor,
			multi: true,
		},
		{
			provide: ANGULARJS_BOOTSTRAP_TIMEOUT,
			useValue: 5440,
		},
		ProjectStorage,
	],
})
export class CoreModule {}
